import Checkout from 'modules/Checkout';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';

const Router = () => (
    <BrowserRouter>
        <QueryParamProvider ReactRouterRoute={Route}>
            <Switch>
                <Route path="/" exact>
                    <Checkout />
                </Route>
            </Switch>
        </QueryParamProvider>
    </BrowserRouter>
);

Router.displayName = 'Router';

export default Router;
